import classNames from "classnames"
import React from "react"
import { CurrierIcon } from "../../../../../../ui/icons/CurrierIcon"
import { Basket } from "../../../../state/checkoutTypes"
import ShippingLabel from "./ShippingLabel"

export interface BasketShippingHeader {
  basket: Basket
  className?: string
}

export const BasketShippingHeader = ({
  basket,
  className,
}: BasketShippingHeader) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-center gap-4",
        className
      )}
    >
      <CurrierIcon width={30} />
      <ShippingLabel basket={basket} />
    </div>
  )
}
